export const LAWYERS = [
  {
    name: 'Mtro. Victor Manuel Garcia Herrera',
    specialty: 'Especialista en Amparo',
    location: 'Querétaro, Querétaro',
    image: './img/LandingClient/CardTop/TopLawyers/mtro_victor_manuel.jpg',
    imageWebp: './img/LandingClient/CardTop/TopLawyers/mtro_victor_manuel.webp',
    alt:'Lic-Victor Manuel',
    link: '/abogado/KQtrhjynUqWuuiEnAnMbPSdYo813'
  },
  {
    name: 'Lic. Janeth Magdalena Gutiérrez Pérez',
    specialty: 'Derecho de la propiedad intelectual',
    location: 'Sinaloa, Mazatlán',
    alt:'Lic-Janeth Gutierrez',
    image: './img/LandingClient/CardTop/TopLawyers/Lic-Janeth-Gutierrez.jpg',
    imageWebp:'./img/LandingClient/CardTop/TopLawyers/Lic-Janeth-Gutierrez.webp',
    link: '/abogado/nxVNxxBnnXfNhyh6vId2JkG1ChJ3'
  },
  {
    name: 'Lic. Patricio González Granados',
    specialty: 'Especialista en Derecho de la propiedad intelectual',
    location: 'CDMX, La Magdalena Contreras',
    image: './img/LandingClient/CardTop/TopLawyers/LIc-patricio_gonzalez.jpg',
    imageWebp: './img/LandingClient/CardTop/TopLawyers/LIc-patricio_gonzalez.webp',
    alt:'Lic-Patricio Gonzalez',
    link: '/abogado/Po2YE8WvkAYMBAjt2F9b3IQuUg63'
  },
  
  {
    name: 'Lic. Marisol Peralta Martínez',
    specialty: 'Especialista en Derecho fiscal',
    location: 'Chihuahua, Chihuahua',
    image: './img/LandingClient/CardTop/TopLawyers/Lic-marisol_peralta.jpg',
    imageWebp: './img/LandingClient/CardTop/TopLawyers/Lic-marisol_peralta.webp',
    alt:'Lic-Marisol Peralta',
    link: '/abogado/cJirbNYYYHRMiSjhzJHhtUWRnUy1'
  },
  {
    name: 'Lic. Patricio González Granados',
    specialty: 'Especialista en Derecho de la propiedad intelectual',
    location: 'CDMX, La Magdalena Contreras',
    image: './img/LandingClient/CardTop/TopLawyers/LIc-patricio_gonzalez.jpg',
    imageWebp: './img/LandingClient/CardTop/TopLawyers/LIc-patricio_gonzalez.webp',
    alt:'Lic-Patricio Gonzalez',
    link: '/abogado/Po2YE8WvkAYMBAjt2F9b3IQuUg63'
  },
  
  {
    name: 'Lic. Marisol Peralta Martínez',
    specialty: 'Especialista en Derecho fiscal',
    location: 'Chihuahua, Chihuahua',
    image: './img/LandingClient/CardTop/TopLawyers/Lic-marisol_peralta.jpg',
    imageWebp: './img/LandingClient/CardTop/TopLawyers/Lic-marisol_peralta.webp',
    alt:'Lic-Marisol Peralta',
    link: '/abogado/cJirbNYYYHRMiSjhzJHhtUWRnUy1'
  },

];

export const FIRMS = [
  {
    name: 'MICHEL ABOGADOS',
    specialty: 'Derecho penal',
    location: 'CDMX, Miguel Hidalgo',
    link: '/despacho/0587ydo8EUfQnWWlrMT0GdKGvaI3',
    alt:'Despacho MICHEL ABOGADOS',
    image: 'https://firebasestorage.googleapis.com/v0/b/contacta-abogado.appspot.com/o/profileImage%2F0587ydo8EUfQnWWlrMT0GdKGvaI3%2Favatar?alt=media&token=4f6de975-fc42-453f-a3e1-c5a632704437',
  },
  {
    name: 'OZM Legal & Business Consulting Services, S.C.',
    specialty: 'Derecho Corporativo',
    location: 'Ciudad de México, Miguel Hidalgo',
    link: '/despacho/ZMJt3S7CUaU4QrFNmEb8iaRGo0K3',
    alt:'Despacho OZM Legal & Business Consulting Services, S.C.',
    image: 'https://firebasestorage.googleapis.com/v0/b/contacta-abogado.appspot.com/o/profileImage%2FZMJt3S7CUaU4QrFNmEb8iaRGo0K3%2Favatar?alt=media&token=4612bf85-d2f9-499b-b628-eed7b91937e3'
  
  },
  {
    name: 'Dra. Angélica Ortiz y Asociados, S.C.',
    specialty: 'Prevención de lavado de dinero',
    location: 'Ciudad de México, Cuauhtémoc',
    alt:'Despacho Dra. Angélica Ortiz y Asociados, S.C.',
    image: './img/LandingClient/CardTop/TopBusiness/despachoDraAngelica.jpg',
    imageWebp:'./img/LandingClient/CardTop/TopBusiness/despachoDraAngelica.webp',
    link: '/despacho/CU79VONt49Wy98tJDb9JCSrEw7h1'
  }, 
 {
    name: 'Imán & Caro Abogados y Asesores',
    specialty: 'Derecho de la Propiedad Intelectual',
    location: 'Yucatán, Mérida',
    alt:'Despacho Imán & Caro Abogados y Asesores',
    link: 'despacho/0Fg5UQiI8bPRlL0hQllosC3FSAu2',
    image: './img/LandingClient/CardTop/TopBusiness/imancaro.jpg',
    imageWebp: './img/LandingClient/CardTop/TopBusiness/imancaro.webp',
  }, 
  {
    name: 'MICHEL ABOGADOS',
    specialty: 'Derecho penal',
    location: 'CDMX, Miguel Hidalgo',
    link: '/despacho/0587ydo8EUfQnWWlrMT0GdKGvaI3',
    alt:'Despacho MICHEL ABOGADOS',
    image: 'https://firebasestorage.googleapis.com/v0/b/contacta-abogado.appspot.com/o/profileImage%2F0587ydo8EUfQnWWlrMT0GdKGvaI3%2Favatar?alt=media&token=4f6de975-fc42-453f-a3e1-c5a632704437',
  },
  {
    name: 'OZM Legal & Business Consulting Services, S.C.',
    specialty: 'Derecho Corporativo',
    location: 'Ciudad de México, Miguel Hidalgo',
    link: '/despacho/ZMJt3S7CUaU4QrFNmEb8iaRGo0K3',
    alt:'Despacho OZM Legal & Business Consulting Services, S.C.',
    image: 'https://firebasestorage.googleapis.com/v0/b/contacta-abogado.appspot.com/o/profileImage%2FZMJt3S7CUaU4QrFNmEb8iaRGo0K3%2Favatar?alt=media&token=4612bf85-d2f9-499b-b628-eed7b91937e3'
  
  },
  
]; 